import carcCodesJson from "./carc-codes.json";
import rarcCodesJson from "./rarc-codes.json";

/**
 * CARC (Claim Adjustment Reason Codes) and RARC (Remittance Advice Remark Codes)
 * Standard X12 healthcare codes for explaining payment adjustments.
 *
 * Source of truth: Ani's "AI training document" — the CARC and RARC worksheets.
 *
 * Sources:
 * - X12 CARC: https://x12.org/codes/claim-adjustment-reason-codes
 * - CMS RARC: https://www.cms.gov/Medicare/Billing/ElectronicBillingEDITrans/Remittance-Advice-Remark-Codes
 */

export const GROUP_CODES: Record<string, string> = {
  CO: "Contractual Obligation - Provider write-off per contract",
  CR: "Correction/Reversal - Correction to prior claim",
  OA: "Other Adjustment - Not classifiable to other groups",
  PI: "Payer Initiated Reduction - Payer policy adjustment",
  PR: "Patient Responsibility - Patient owes this amount",
};

export const CARC_CODES = carcCodesJson as Record<string, string>;
export const RARC_CODES = rarcCodesJson as Record<string, string>;

export function getAdjustmentDescription(
  _group: string,
  code: string
): string | null {
  return CARC_CODES[code] || null;
}

export function getGroupDescription(group: string): string | null {
  return GROUP_CODES[group] || null;
}

export function getRemarkDescription(code: string): string | null {
  return RARC_CODES[code] || null;
}

export function formatAdjustment(
  group: string,
  code: string,
  amount: number
): string {
  const formattedAmount = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
  return `${group}-${code} ${formattedAmount}`;
}
